import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Calendar, MapPin } from "lucide-react";

const typeColor = {
  practice: "bg-blue-500/20 text-blue-300 border-blue-400/30",
  game: "bg-red-500/20 text-red-300 border-red-400/30",
  tournament: "bg-yellow-500/20 text-yellow-300 border-yellow-400/30",
  clinic: "bg-cyan-500/20 text-cyan-300 border-cyan-400/30",
  camp: "bg-purple-500/20 text-purple-300 border-purple-400/30",
  service: "bg-green-500/20 text-green-300 border-green-400/30",
  other: "bg-slate-500/20 text-slate-300 border-slate-400/30",
};

export default function Schedule() {
  const [events, setEvents] = useState([]);
  useEffect(() => { api.get("/schedule").then((r) => setEvents(r.data)); }, []);
  const sorted = [...events].sort((a, b) => new Date(a.date) - new Date(b.date));
  return (
    <div data-testid="schedule-page" className="py-20">
      <div className="max-w-5xl mx-auto px-4 sm:px-6">
        <div className="eyebrow mb-3">Team Calendar</div>
        <h1 className="font-display text-5xl sm:text-6xl uppercase font-bold tracking-tight">Schedule</h1>
        <p className="text-slate-400 mt-4">Practices, games, tournaments, camps & team events.</p>
        <div className="mt-10 space-y-3">
          {events.length === 0 && (
            <div className="kr-card rounded-xl p-12 text-center" data-testid="schedule-tbd">
              <div className="font-display text-4xl uppercase text-[#00E5FF]">TBD</div>
              <p className="text-slate-400 mt-3">Schedule will be posted soon. Check back for practices, games, tournaments, and team events.</p>
            </div>
          )}
          {sorted.map((e) => {
            const d = new Date(e.date);
            return (
              <div key={e.id} className="kr-card rounded-xl p-5 flex flex-col sm:flex-row sm:items-center gap-4" data-testid={`event-${e.id}`}>
                <div className="text-center sm:w-20 shrink-0">
                  <div className="font-display text-3xl text-[#00E5FF]">{d.getDate()}</div>
                  <div className="text-xs uppercase tracking-widest text-slate-400">{d.toLocaleString('en-US', { month: 'short' })}</div>
                </div>
                <div className="flex-1">
                  <div className="font-display text-xl uppercase">{e.title}</div>
                  <div className="text-slate-400 text-sm mt-1 flex flex-wrap gap-3">
                    <span><Calendar size={14} className="inline mr-1" />{d.toLocaleString('en-US', { weekday: 'short', hour: 'numeric', minute: '2-digit' })}</span>
                    {e.location && <span><MapPin size={14} className="inline mr-1" />{e.location}</span>}
                    {e.opponent && <span>vs {e.opponent}</span>}
                  </div>
                  {e.notes && <div className="text-slate-500 text-xs mt-1">{e.notes}</div>}
                </div>
                <span className={`text-[10px] uppercase tracking-widest border rounded-full px-3 py-1 ${typeColor[e.type] || typeColor.other}`}>{e.type}</span>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
